module.exports = __webpack_public_path__ + "img/shouye.fa009bdb.svg";